if (typeof window.Field === 'undefined') {
    window.Field = class Field {
        constructor(input) {
            this.input = input;
        }

        validate() {
            const isValid = this.input.checkValidity();
            this.input.classList.toggle('is-invalid', !isValid);

            return isValid;
        }

        report() {
            this.input.reportValidity();
        }
    };
}
